// js/timer-worker.js
let timerID = null;
let interval = 100;

self.onmessage = function(e) {
    if (e.data.command === "start") {
        interval = e.data.interval;
        if (timerID) clearInterval(timerID);
        timerID = setInterval(function() {
            postMessage("tick");
        }, interval);
    } else if (e.data.command === "stop") {
        clearInterval(timerID);
        timerID = null;
    }
};